import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function JoinGroup() {
  const query = useQuery();
  const navigate = useNavigate();

  const token = query.get('token');

  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    if (!token) {
      toast.error('Invalid invitation link.');
      setLoading(false);
      return;
    }

    async function fetchInvite() {
      try {
        const res = await api.get(`/api/invites/validate?token=${token}`);
        setGroup(res.data.group);
      } catch (err) {
        console.error('Error validating invite:', err);
        toast.error(err.response?.data?.message || 'Failed to validate invitation.');
      } finally {
        setLoading(false);
      }
    }

    fetchInvite();
  }, [token]);

  const handleJoin = async () => {
    setJoining(true);
    try {
      await api.post('/api/invites/join-group', { token });
      toast.success('Successfully joined the group!');
      navigate('/groups');
    } catch (err) {
      console.error('Join error:', err);
      toast.error(err.response?.data?.message || 'Failed to join group.');
    } finally {
      setJoining(false);
    }
  };

  if (loading) {
    return <div className="p-6 text-center">Loading invitation details...</div>;
  }

  if (!group) {
    return <div className="p-6 text-center text-red-600">Invitation invalid or expired.</div>;
  }

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded shadow">
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      <h2 className="text-2xl font-bold mb-4">You're invited to join the group:</h2>
      <p><strong>{group.name}</strong></p>
      <p><strong>Animal:</strong> {group.animal}</p>
      <p><strong>State:</strong> {group.state}</p>
      <button
        onClick={handleJoin}
        disabled={joining}
        className="mt-6 w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 disabled:opacity-50"
      >
        {joining ? 'Joining...' : 'Join Group'}
      </button>
    </div>
  );
}
